module.exports = __webpack_public_path__ + "media/photography/sectionImage1-acab25c5.png";